var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "box", attrs: { fluid: "", "grid-list-md": "" } },
    [
      _c(
        "v-card-title",
        {
          staticClass: "d-flex align-end px-0",
          attrs: { "primary-title": "" }
        },
        [
          _c(
            "div",
            { staticClass: "d-flex align-center" },
            [
              _c(
                "v-icon",
                { staticClass: "mr-2", attrs: { color: "black", size: 30 } },
                [_vm._v("mdi-bell")]
              ),
              _vm._v(" "),
              _c("h3", { staticClass: "font-weight-regular text-uppercase" }, [
                _vm._v("Notificações")
              ]),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  staticClass: "ml-3",
                  attrs: {
                    small: "",
                    outlined: "",
                    rounded: "",
                    color: "secondary"
                  },
                  on: {
                    click: function($event) {
                      _vm.send = true
                    }
                  }
                },
                [_vm._v("criar notificação")]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("v-spacer")
        ],
        1
      ),
      _vm._v(" "),
      _c("new-send", {
        attrs: { visible: _vm.send },
        on: {
          close: function($event) {
            return _vm.closeSendDialog()
          }
        }
      }),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c("list")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-460d3d4b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-460d3d4b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Notifications/Index.vue
// module id = null
// module chunks = 